// complex-tooltip.js

;(( {$, $$}) => {
    const shownClass = 'complex-tooltip--shown'
    const tooltips = $$('.complex-tooltip')
    const autoHideDelay = 300
    let hideTimer = null

    tooltips.forEach(tooltip => {
        const trigger = tooltip.querySelector('.complex-tooltip__trigger')
        const label = tooltip.querySelector('.complex-tooltip__label')

        if (!trigger) {
            console.error('complex-tooltip__trigger not defined')
            return
        }

        const onlyOverflow = tooltip.dataset.hasOwnProperty('onlyOverflow')
        const isDisabled = () => onlyOverflow && !(label.offsetHeight < label.scrollHeight)

        const hideAllTooltips = () => {
            clearTimeout(hideTimer)
            tooltips.forEach(t => {
                t.classList.remove(shownClass)
                t.classList.remove('cursor-pointer')
            })
        }

        trigger.addEventListener('mouseenter', () => {
            if (isDisabled()) { return }

            hideAllTooltips()

            tooltip.classList.add(shownClass)
            tooltip.classList.add('cursor-pointer')
        })

        trigger.addEventListener('mouseleave', () => {
            hideTimer = setTimeout(() => {
                tooltip.classList.remove(shownClass)
                tooltip.classList.remove('cursor-pointer')
            }, autoHideDelay)
        })
 
        
        
    })
})(CNS);